/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Creating_AudioInputs */

const en_mobile_creating_audio = /** @type {(inputs: Mobile_Creating_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating audio …`)
};

const es_mobile_creating_audio = /** @type {(inputs: Mobile_Creating_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando audio …`)
};

/**
* | output |
* | --- |
* | "Creating audio …" |
*
* @param {Mobile_Creating_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_creating_audio = /** @type {((inputs?: Mobile_Creating_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Creating_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_creating_audio(inputs)
	return en_mobile_creating_audio(inputs)
});